import React from 'react';

function Logo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="129.037"
      height="76.199"
      viewBox="0 0 129.037 76.199"
    >
      <g transform="translate(-208.73 -125.305)">
        <g
          fill="#ebeff2"
          data-name="Group 7520"
          transform="translate(208.73 183.119)"
        >
          <path
            d="M215.746 337.98c5.83 0 8.676 1.976 8.676 9.126 0 7.12-2.847 9.256-8.676 9.256h-7.016V337.98zm-.343 3h-3.192v12.37h3.189c4.061 0 5.3-1.029 5.3-6.224.005-5.401-1.236-6.141-5.3-6.141z"
            data-name="Path 1851"
            transform="translate(-208.73 -337.98)"
          ></path>
          <path
            d="M295.844 356.372H291.6a240.245 240.245 0 00-8.1-13.848v13.848h-3.4V337.99h4.564a209.87 209.87 0 017.729 13.268V337.99h3.454v18.382z"
            data-name="Path 1852"
            transform="translate(-260.676 -337.987)"
          ></path>
          <path
            d="M358.777 351.773h-8.045c-.528 1.636-1 3.192-1.426 4.589h-3.666c1.742-5.487 4.431-12.9 6.673-18.382h5.46c1.872 5.906 4.564 13.477 6.622 18.382h-3.851a134.358 134.358 0 01-1.767-4.589zm-4.273-10.84c-.923 2.373-1.9 5.089-2.849 7.86h6.118a190.803 190.803 0 01-2.558-7.86z"
            data-name="Path 1853"
            transform="translate(-308.379 -337.98)"
          ></path>
          <path
            d="M429.925 369.626h-4.061c-.528-2.716-1.529-6.883-2.161-8.995-.634 2.795-1.742 6.567-2.586 8.995h-4.033c-1.293-4.668-2.768-9.311-4.325-13.426h3.454a92.815 92.815 0 013.059 10.075c.923-2.692 2.346-7.675 2.9-10.075h3.192c.871 2.61 2.085 7.2 2.716 10.075a92.029 92.029 0 003.12-10.075h3.323a126.835 126.835 0 01-4.598 13.426z"
            data-name="Path 1854"
            transform="translate(-357.231 -351.241)"
          ></path>
          <path
            d="M503.171 369.626H499.9V356.2h3.271z"
            data-name="Path 1855"
            transform="translate(-420.655 -351.241)"
          ></path>
          <path
            d="M532.389 356.2v.659c-1.9 3.059-5.144 7.675-6.91 9.918h6.721v2.847h-11.84v-.659c2.558-3.244 5.7-7.754 7.016-9.918h-6.567V356.2z"
            data-name="Path 1856"
            transform="translate(-435.547 -351.241)"
          ></path>
        </g>
        <g data-name="Group 7534" transform="translate(268.344 136.002)">
          <g data-name="Group 7522" transform="translate(19.649 23.285)">
            <g data-name="Group 7521">
              <path
                fill="#597b8b"
                d="M0 0H17.464V2.177H0z"
                data-name="Rectangle 4767"
                transform="rotate(-87.88 9.058 8.729)"
              ></path>
            </g>
          </g>
          <g data-name="Group 7525" transform="translate(0 17.217)">
            <g data-name="Group 7523">
              <path
                fill="#597b8b"
                d="M0 0H18.823V2.177H0z"
                data-name="Rectangle 4768"
                transform="rotate(-87.151 9.88 9.4)"
              ></path>
            </g>
            <g data-name="Group 7524" transform="translate(6.525 .014)">
              <path
                fill="#597b8b"
                d="M0 0H22.371V2.177H0z"
                data-name="Rectangle 4769"
                transform="rotate(-86.221 11.923 11.161)"
              ></path>
            </g>
          </g>
          <g data-name="Group 7527" transform="translate(13.052 19.114)">
            <g data-name="Group 7526">
              <path
                fill="#597b8b"
                d="M0 0H23.332V2.177H0z"
                data-name="Rectangle 4770"
                transform="rotate(-86.663 12.345 11.646)"
              ></path>
            </g>
          </g>
          <g data-name="Group 7529" transform="translate(31.972 18.152)">
            <g data-name="Group 7528">
              <path
                fill="#597b8b"
                d="M0 0H2.177V17.971H0z"
                data-name="Rectangle 4771"
                transform="rotate(-47.103 1.83 .797)"
              ></path>
            </g>
          </g>
          <g data-name="Group 7533" transform="translate(34.335)">
            <g data-name="Group 7530" transform="translate(7.612)">
              <path
                fill="#597b8b"
                d="M0 0H2.177V19.329H0z"
                data-name="Rectangle 4772"
                transform="rotate(-46.3 1.84 .786)"
              ></path>
            </g>
            <g data-name="Group 7531" transform="translate(2.498 4.864)">
              <path
                fill="#597b8b"
                d="M0 0H2.177V23.373H0z"
                data-name="Rectangle 4773"
                transform="rotate(-46.803 1.834 .793)"
              ></path>
            </g>
            <g data-name="Group 7532" transform="translate(0 11.388)">
              <path
                fill="#597b8b"
                d="M0 0H2.177V22.176H0z"
                data-name="Rectangle 4774"
                transform="rotate(-46.528 1.838 .79)"
              ></path>
            </g>
          </g>
        </g>
        <path
          fill="#a7bcc8"
          d="M431.333 126.163a1.359 1.359 0 00-1.766-.762 12.266 12.266 0 00-2.5 1.347c-3.331 2.322-5.345 6.159-6.82 10.543-5.059-2.67-10.149-4.15-15.132-2.172-7.688 3.056-9.991 12.348-12.217 21.337-.5 2.033-1 4.036-1.549 5.952-1.66-.991-3.345-2.074-5.051-3.171-7.863-5.057-15.992-10.288-23.825-7.177-4.953 1.968-7.55 6.382-9.275 11.61-4.885-2.61-9.863-4.006-14.92-2a1.36 1.36 0 101 2.528c4.267-1.7 8.627-.367 13.123 2.126-.6 2.224-1.1 4.54-1.592 6.834-.144.667-.286 1.334-.433 2a1.36 1.36 0 001.037 1.619 1.345 1.345 0 00.291.033 1.36 1.36 0 001.328-1.07c.147-.667.291-1.339.433-2.008.438-2.039.871-4.05 1.361-5.966 1.755 1.1 3.533 2.324 5.337 3.565 5.922 4.077 12 8.265 18.161 8.265a12.823 12.823 0 004.8-.92c5.106-2.03 7.871-6.725 9.8-12.263 5.179 2.708 10.378 4.248 15.42 2.243 7.759-3.084 9.95-12.443 12.07-21.5.457-1.951.92-3.922 1.44-5.824 1.734 1.056 3.495 2.218 5.28 3.4l.656.433a1.361 1.361 0 001.5-2.272l-.656-.433c-1.979-1.309-3.976-2.629-5.982-3.818 1.336-4.126 3.111-7.683 5.958-9.67a9.718 9.718 0 011.954-1.051 1.35 1.35 0 00.769-1.758zm-49.2 49.987c-6.445 2.561-13.23-2.112-20.415-7.06-2.019-1.391-4.058-2.792-6.113-4.042 1.524-4.874 3.718-8.81 7.873-10.462 6.529-2.594 13.728 2.036 21.345 6.935 1.889 1.214 3.791 2.439 5.7 3.552-1.731 5.18-4.091 9.369-8.394 11.078zm35.645-29.608c-2.052 8.758-3.987 17.032-10.426 19.59-4.232 1.682-8.788.237-13.573-2.341.645-2.18 1.206-4.439 1.761-6.681 2.156-8.7 4.191-16.923 10.579-19.462 4.186-1.663 8.644-.264 13.314 2.283-.617 2.156-1.139 4.394-1.659 6.612z"
          data-name="Path 1857"
          transform="translate(-93.662)"
        ></path>
        <path
          fill="#3aaa35"
          d="M616.438 230.912l3.435-.016-2.077 2.738 1.075 3.263-3.244-1.132-2.771 2.033.073-3.435-2.79-2.008 3.29-.993 1.045-3.271z"
          data-name="Path 1858"
          transform="translate(-292.163 -74.84)"
        ></path>
        <path
          fill="#e40134"
          d="M547.682 167.843l-1.412 4.218-2.49-3.688-4.45-.038 2.738-3.508-1.339-4.243 4.183 1.521 3.623-2.586-.152 4.447 3.576 2.645z"
          data-name="Path 1859"
          transform="translate(-240.624 -24.903)"
        ></path>
        <path
          fill="#007bc4"
          d="M422.5 212.956l-2.86 1.546.514-3.212-2.354-2.245 3.214-.5 1.407-2.931 1.47 2.9 3.225.433-2.305 2.3.585 3.2z"
          data-name="Path 1860"
          transform="translate(-152.17 -58.471)"
        ></path>
        <path
          fill="#ffd500"
          d="M491.4 301.083l3.285 2.92-4.316.833-1.761 4.025-2.126-3.846-4.374-.433 3-3.209-.942-4.295 3.982 1.864 3.791-2.224z"
          data-name="Path 1861"
          transform="translate(-198.977 -124.812)"
        ></path>
      </g>
    </svg>
  );
}

export default Logo;
